export default __webpack_public_path__ + "c47ac59cb51235b37d41fd116561d31b.png";